<template>
  <div
    class="myPlacementTestResults"
    v-if="
      myPlacementTestResults &&
        myPlacementTestResults.results &&
        myPlacementTestResults.results.length > 0
    "
  >
    <h3 class="testHistoryTitle">{{ $t("Your results") }}</h3>
    <div class="testHistory">
      <div
        class="placementTestResultsRow"
        v-for="{
          id,
          score,
          created,
          placement_test_name
        } in myPlacementTestResults.results"
        :key="id"
      >
        <section>
          <span>{{ placement_test_name }} - </span>
          <span>({{ formatFromNow(created) }})</span>
        </section>
        <section>
          <span>{{ score }}%</span>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import formatTS from "@/mixins/momentMixin";
import { mapActions, mapState } from "vuex";
export default {
  name: "MyPlacementTestResults",
  mixins: [formatTS],
  computed: {
    ...mapState("placementTest", ["myPlacementTestResults"])
  },
  methods: {
    ...mapActions("placementTest", ["getMyPlacementTestResults"])
  },
  created() {
    this.getMyPlacementTestResults();
  }
};
</script>

<style lang="scss">
.myPlacementTestResults {
  padding: 16px;
}
.testHistory {
  // max-height: 350px;
  // overflow-y: auto;
  // margin: 12px 8px;
}
.testHistoryTitle {
  margin: 12px 4px;
  text-align: center;
}
.placementTestResultsRow {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  &:nth-child(even) {
    background: #f3f3f3;
  }
  .reviewBtn {
    margin: 0 8px;
  }
}
</style>
